/* eslint-disable camelcase */
import {
  PhoneInput, FormFlow, Form, Select,
} from '@common/vanilla_ui/general';
import { apiRequest, generateJWT } from '@common/api/utils';
import gtmTracking from '@common/vanilla_ui/tracking/gtm';
import { ResendOtpForm } from '@common/vanilla_ui/forms';
import { OtpForm, RegisterForm } from '@common/vanilla_ui/forms/handlers';
import Toastify from 'toastify-js';
import registrationTracking from './registrationTracking';

let loggedIn = false;
let phoneVerified = false;
const formId = 'marketing-form';
const positionFieldId = 'marketing-form-otp-position';
const DEFAULT_HEADER = 'Free Career Counselling is just a call away!';
const OTP_FORM_HEADER = 'Request a callback';

const track = (eventName, eventType = 'click', value = null) => {
  if (window.storeEsEvent) {
    window.storeEsEvent(
      `sales-course-landing-marketing-form-${eventName}`, eventType, value,
    );
  }
};

const getPayload = (values) => {
  const program = 'sales_course';

  const {
    email,
    phone_number,
    otp,
  } = values;
  return {
    user: {
      email,
      phone_number,
      otp,
      skip_existing_user_check: true,
      program,
    },
    type: 'sales_course_landing',
    source: 'Sales Course Page',
  };
};

const initializeOtpFormInputs = () => {
  new PhoneInput('marketing-form__phone');
};

const initializeRegisterFormInputs = () => {
  if (!phoneVerified) {
    new PhoneInput('marketing-form-submit__phone');
  }
};

const registerSalesCourse = async () => {
  try {
    const jwt = await generateJWT();
    const response = await apiRequest(
      'POST',
      '/courses/registration',
      {
        course_slug: 'lms-sales-course',
      },
      {
        headers: {
          'X-user-token': jwt,
        },
      },
    );
    const { success, message } = response;
    if (success) {
      window.location.replace(`/academy/mentee-dashboard/`);
      Toastify({
        text: 'Sales course registered successfully',
        className: 'toastify-success',
      }).showToast();
    } else {
      Toastify({
        text: message || 'Something went wrong',
        className: 'toastify-danger',
      }).showToast();
    }
  } catch (e) {
    const errorMessage = e?.responseJson?.message || 'Something went wrong';
    Toastify({
      text: errorMessage,
      className: 'toastify-danger',
    }).showToast();
    window.GTMtracker?.pushEvent({
      event: 'gtm_custom_click',
      data: {
        click_type: 'sales_course_registration_error',
        click_text: errorMessage,
      },
    });
  }
};

const setupMainForm = () => {
  const otpInput = document.getElementById(`${formId}__otp`);
  const otpFormEl = document.getElementById(`${formId}-otp`);
  const submitFormEl = document.getElementById(`${formId}-submit`);
  const resendOtpFormEl = document.querySelector(`.${formId}__otp-hint`);
  const formEl = document.getElementById(formId);
  const titleElement = formEl.querySelector('.section-header__title');

  const form = new FormFlow(
    'marketing-form', 'marketing-form', 'page', 'register',
  );

  const updateHeaderTitle = (newTitle = DEFAULT_HEADER) => {
    if (titleElement) {
      titleElement.textContent = newTitle;
    }
  };

  const programEl = document.querySelector('div[data-program]');
  const program = programEl ? programEl.getAttribute(
    'data-program',
  ) : 'academy';

  const formFlowEl = document.querySelector('#marketing-form');
  loggedIn = formFlowEl.getAttribute('data-logged-in') === 'true';
  phoneVerified = formFlowEl.getAttribute('data-phone-verified') === 'true';

  const positionFieldEl = document.getElementById(positionFieldId);
  if (positionFieldEl) new Select(positionFieldId);

  registrationTracking.initialize();

  form.setFormHandler('register', element => {
    const { otpMsgForm, otpVoiceForm } = ResendOtpForm.initialize(
      'marketing-form', track,
    );
    const endpoint = phoneVerified
      ? '/users/v2/' : '/users/v2/account/verify';

    const registerForm = new Form(element, {
      method: 'POST',
      endpoint: loggedIn ? endpoint : '/users/v2/verify',
      createPayload: getPayload,
    });

    const otpFormId = 'marketing-form-otp';
    const otpForm = new Form(
      document.getElementById(otpFormId),
      {
        method: loggedIn ? 'PUT' : 'POST',
        endpoint: loggedIn ? '/users/v2/account' : '/users/v2/',
        createPayload: values => ({
          user: {
            ...values,
            program,
            skip_existing_user_check: true,
          },
          type: 'marketing',
          account_type: 'academy',
          source: 'Sales Course Page',
          'cf-turnstile-response': values['cf-turnstile-response'],
        }),
        validations: {
          phone_number: 'mobile',
          orgyear: 'required',
          email: 'email',
        },
      },
    );

    otpForm.addEventListener('invalidfields', (errors) => {
      const errorMessage = errors[Object.keys(errors)[0]];
      Toastify({
        text: errorMessage,
        className: 'toastify-danger',
      }).showToast();
    });

    const otpFormSubmittedCb = () => {
      const submitFormId = 'marketing-form-submit';
      const phoneNumberVal = otpForm.getFieldValue('phone_number');
      if (phoneNumberVal) {
        const phoneNumberArr = phoneNumberVal.split('-');
        const countryCode = phoneNumberArr[0];
        const phoneNumber = phoneNumberArr[1];
        const countryCodeEl = document.getElementById(
          `input-${submitFormId}__phone-code`,
        );
        const phoneNumberEl = document.getElementById(
          `${submitFormId}__phone-number`,
        );
        countryCodeEl.value = countryCode;
        phoneNumberEl.value = phoneNumber;
      }
    };

    const enableOtpForm = () => {
      otpFormEl.classList.add('hidden');
      submitFormEl.classList.remove('hidden');
      resendOtpFormEl.classList.remove('hidden');
      updateHeaderTitle(OTP_FORM_HEADER);
    };

    OtpForm.initialize({
      registerForm,
      otpVoiceForm,
      otpMsgForm,
      initializeInputs: initializeOtpFormInputs,
      parentFormId: formId,
      formId: 'marketing-form-otp',
      track,
      otpForm,
      submittedCallback: otpFormSubmittedCb,
      enableOtpForm,
    });

    const registerFormSubmitCb = () => {
      if (!phoneVerified) {
        registerForm.updateField(
          'otp', otpInput.value,
        );
      }
    };

    const registerFormSubmittedCb = async () => {
      gtmTracking.sendFormSubmitStatus('marketing-form-submit', true);
      await registerSalesCourse();
      if (!phoneVerified) {
        registerForm.setDisabled(true);
        track(
          'register-step-complete', 'click',
          registerForm.getFieldValue('email'),
        );
      }
      track('open-dashboard', 'click');
    };

    RegisterForm.initialize({
      registerForm,
      formId,
      initializeInputs: initializeRegisterFormInputs,
      submitCallback: registerFormSubmitCb,
      submittedCallback: registerFormSubmittedCb,
    });
  });
  form.initialize();
};

const initialize = () => {
  const formEl = document.getElementById(formId);
  if (formEl) {
    setupMainForm();
  }
};

export default { initialize };
